import type { PerpsMarket } from "./types";

type BuildMarketsParams = {
  collateralSynthMarketId: string;
  collateralTokenAddress: string;
};

export function buildSynthetixMarkets({
  collateralSynthMarketId,
  collateralTokenAddress,
}: BuildMarketsParams): PerpsMarket[] {
  return [
    {
      key: "eth",
      label: "ETH / USD",
      marketId: "100",
      chartSymbol: "BINANCE:ETHUSDT",
      defaultPriceUsd: "2000",
      synthMarketId: collateralSynthMarketId,
      collateralTokenAddress,
      collateralDecimals: 18,
    },
    {
      key: "btc",
      label: "BTC / USD",
      marketId: "200",
      chartSymbol: "BINANCE:BTCUSDT",
      defaultPriceUsd: "60000",
      synthMarketId: collateralSynthMarketId,
      collateralTokenAddress,
      collateralDecimals: 18,
    },
    {
      key: "snx",
      label: "SNX / USD",
      marketId: "300",
      chartSymbol: "BINANCE:SNXUSDT",
      defaultPriceUsd: "3",
      synthMarketId: collateralSynthMarketId,
      collateralTokenAddress,
      collateralDecimals: 18,
    },
  ];
}
